import { buildClasses } from "../utils/buildClasses";
import { STANDARD_MAIN_CONTENT_CARD_PADDING_X } from "../rye/RyeMainContentContainerBase";
import { TransactionsHeader } from "./TransactionsHeader";
import {
  DisableFilteringAndSortingContext,
  TRANSACTIONS_TABLE_INSET,
} from "./TransactionsTable";

/**
 * A transactions table's column headers, drawn in the top bar above it rather
 * than in the scrolling table, so the table's scrollbar starts at its first
 * row. They line up with the table's columns, which always fit its width.
 */
export function TransactionsColumnHeaders({
  disableFilteringAndSorting = false,
}: {
  disableFilteringAndSorting?: boolean;
}): JSX.Element {
  return (
    <DisableFilteringAndSortingContext.Provider
      value={disableFilteringAndSorting}
    >
      {/* Above the table, so its filter menus open over the rows. */}
      <div
        className={buildClasses(
          "relative",
          "z-20",
          "shrink-0",
          STANDARD_MAIN_CONTENT_CARD_PADDING_X,
        )}
      >
        <div className={TRANSACTIONS_TABLE_INSET}>
          <TransactionsHeader />
        </div>
      </div>
    </DisableFilteringAndSortingContext.Provider>
  );
}
